import React, { useMemo } from "react";
import { statusCategories } from "../../../Findings/FindingDetailsPane/FindingDetailsPaneHeader/Statuses/StatusUtils";
import PieChart from "../PieChart";
import useSeverityAsPriority from "../../../General/useSeverityAsPriority";
import { capitalize } from "lodash-es";
import type { SelectedScope } from "../../../types/scope";
import type { SeverityMappingItem } from "../../../types/AppPreferencesProvider";

interface SeverityCategory {
  title: string;
  fill: string;
  sort: number;
}

interface ChartFilterValue {
  type: string;
  key: string;
  id: string;
}

export interface FindingsBySeverityProps {
  selectedScope?: SelectedScope | null;
  filterToExecute?: string | null;
  scopeToExecute?: string | null;
  id: string;
  setIsReadyToExport?: ((isReady: boolean) => void) | null;
}

const FindingsBySeverity: React.FC<FindingsBySeverityProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  setIsReadyToExport,
}) => {
  const { currentSeverityMapping, severityDisplay } = useSeverityAsPriority();
  const filtersConfig = {
    filtersjson: filterToExecute || null,
    scopesjson: scopeToExecute || null,
    scopesid: selectedScope?.value?.id,
  };

  const chartFilterValue: ChartFilterValue[] = [
    {
      type: "category",
      key: statusCategories.OPEN,
      id: statusCategories.OPEN,
    },
  ];

  const skip =
    (!scopeToExecute && !selectedScope?.value?.id) || !filterToExecute;

  const chartName = `findings-by-severity-div-${id}`;

  const categories = useMemo(() => {
    return currentSeverityMapping?.reduce<Record<string, SeverityCategory>>(
      (acc, curr: SeverityMappingItem, index) => {
        acc[curr.value] = {
          title: capitalize(curr.name),
          fill: curr.color,
          sort: index,
        };

        return acc;
      },
      {}
    );
  }, []);

  return (
    <PieChart
      categories={categories}
      skip={skip}
      groupBy={["finding.severity"]}
      filtersConfig={filtersConfig}
      legendTitle={severityDisplay}
      chartName={chartName}
      chartFilterValue={chartFilterValue}
      actualFilterField={"remediation_item.severity"}
      dataSubject={"Findings"}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default FindingsBySeverity;
